// Зона ролика режима «Повторить движение» (13.10): блок «Ролик» Видеостудии (MotionZone — раскадровка, ручки отрезка,
// что проверили) на месте демо карточки. Загрузка — штатный пикер слота видео («Загрузить / Из моих генераций»),
// скрытый input слота рисуем здесь: UploadsRow в этом режиме не смонтирован.
import MotionZone from '../../scene/components/MotionZone'
import { useGenerate } from '../../../context/GenerateContext'
import { clipHints } from './motionTool'
import type { MotionMode } from './useMotionMode'

const noop = () => {}

export default function MotionClipZone({ motion, onUpload, disabled }: {
	motion: MotionMode
	/** Клик «Загрузить ролик» / «Заменить»: меню источника у кнопки (makeShowPicker слота видео). */
	onUpload: (button: HTMLElement) => void
	disabled: boolean
}) {
	const { videoInputRef, handleVideoUpload } = useGenerate()
	const hints = clipHints(motion.model, motion.limits)
	return (
		<div className="gtm__clip">
			<MotionZone
				video={motion.clip}
				cap={motion.limits.cap}
				min={motion.limits.min}
				replace={motion.limits.replace}
				bare
				uploadTile
				removeInSlot
				warnOnly
				plain
				lead={hints.lead}
				reqs={hints.reqs}
				readonly={disabled}
				busy={motion.busy}
				shotVideo={null}
				onChange={motion.onClipChange}
				onUpload={onUpload}
				onUseShotVideo={noop}
				onDropFile={motion.dropClip}
				onRemove={motion.removeClip}
				onMeta={motion.onClipMeta}
			/>
			<input
				ref={videoInputRef}
				type="file"
				accept="video/mp4,video/quicktime,video/webm"
				onChange={handleVideoUpload}
				style={{ display: 'none' }}
				aria-hidden="true"
				tabIndex={-1}
			/>
		</div>
	)
}
